<template>
  <div class="skillTopic assessment-mb"  :class="{'skillTopicPC':$store.state.innerWidth>768}">
    <div class="topic-pc">
     <div class="topic-content">
        <div class="skillTitle Medium">{{$t('message.Skill-Career Quiz')}}</div>
          <div class="questionNo SemiBold center" v-if="$store.state.innerWidth>768">
            {{$t('message.Q')}}{{swiperIndex}}/{{totalRows}}
          </div>
        <div class="relative">
          <div class="paginationGroup">
            <div class="swiper-pagination" slot="pagination">
            </div>
            <div class="paginationImg" >
              <img  src="../images/assessment/assessment-52.png" ref="assessmentImg"/>
            </div>
          </div>
          <div class="questionNo SemiBold center" v-if="$store.state.innerWidth<=768">
            {{$t('message.Q')}}{{swiperIndex}}/{{totalRows}}
          </div>
          
          <swiper :options="swiperOption" class="swiperCarrousel" ref="honorSwiper">
              <swiper-slide class="swiper-slide box-slide swiper-no-swiping" v-for="(question,index) in questionList">
                  <div class="questionTip Medium center">
                     {{$store.getters.getObject(question.langData).question}}
                  </div>
                  <div class="questionTitle SemiBold center">
                     {{$store.getters.getObject(question.langData).questionHalf}}
                  </div>
                  <div class="questionImage center">
                    <img :class="[question.value>=(index+1)?'activeImg':'inactiveImg']" v-for="(img,index) in question.image"  :src="img"  />
                  </div>
                  <div class="selectTip center Medium mainColor">
                    <span class="" v-if="question.value==(index+1)" v-for="(answer,index) in question.answers">
                      {{$store.getters.getObject(answer.langData).answer}}
                    </span>
                  </div>
                  <div class="sliderGroup">
                    <vue-slider 
                    :max="5" 
                    :min="1" 
                    :tooltip="'none'" 
                    :marks="true"
                    v-model="question.value" 
                    @change = "handleChange"
                    >
                      <template v-slot:step="{ label, active }">
                        <div :class="['custom-step', { active }]"></div>
                      </template>
                    </vue-slider>
                  </div>
              </swiper-slide>
          </swiper>
          <div class="SkipShow center SemiBold mainColor"  v-if="occupationsList.length>0">
            <span class="pointer" role="button" :aria-label="$t('message.Show result')" @click="gotoMatches">{{$t('message.Show result')}}</span>
          </div>
          <div style="height:18px;width:100%;" v-else>
          </div>
          <div class="swiper-button-prev"  slot="button-prev">
            <i class="icon-arrow-down"></i>
          </div>
          <div class="swiper-button-next" slot="button-next">
            <i class="icon-arrow-down"></i>
          </div>
          <div class="showResultBtn " v-if="swiperIndex==questionList.length"  @click="gotoMatches" :class="{'show':swiperIndex==questionList.length}">
              <span class="pointer">
                <a href="javascript:;" style="color: inherit">{{$t('message.Show result')}}</a>
              </span>
          </div>
        </div>
     </div>
     <div class="">
        <div class="matches">
           <div class="matchesTitle SemiBold mainColor">
              {{$t('message.Your Career Matches')}}
           </div>
           <div class="matchesTip" v-if="occupationsList.length==0">
            {{$t('message.resultTip')}}
           </div>
           <div class="o-List row">
             <div class="o-box col-xs-6 col-sm-4" v-for="(occupation, index) in occupationsList">
              <div class="box" @click="goOccupationDetail(occupation)"> 
                 <div class="o-title Bold">
                    <span class="fourline-box wrap2">
                      <a href="javascript:;" style="color: inherit">{{$store.getters.getContent(occupation.title)}}</a>
                    </span>
                 </div>
                   <img class="img1" v-if="index%3==0" src="../images/deco-19.png" />
                   <img class="img2" v-if="index%3==1" src="../images/O green1 copy.png" />
                   <img class="img3" v-if="index%3==2" src="../images/Vector Smart Object2.png" />
               </div>
             </div>
           </div>
        </div>
     </div>
     <div class="bgImage">
       <img class="bgImg1 noSelect" src="../images/deco-07.png" />
       <img class="bgImg2 noSelect" src="../images/deco-05.png" />
       <img class="bgImg3 noSelect" src="../images/deco-14.png" />
       <img class="bgImg4 noSelect" src="../images/deco-12.png" />
       <img class="bgImg5 noSelect" src="../images/deco-31.png" />
     </div>
     </div>
  </div>
</template>
<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
export default {
    data() {
        return {
            swiperOption: {
                pagination: {
                  el: '.swiper-pagination',
                  type: 'progressbar'
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                on:{
                  transitionEnd: this.transitionEnd,
                  transitionStart: this.transitionStart,
                },
            },
            questionList:[],
            occupationsList:[],
            totalRows:0,
            value:1,
            swiperIndex:1,
            answerIndex:0,
            getQuestions:false,
            marks: val => val % 1 === 0,
        }
    },   
    components: {
        VueSlider
    },
    props: ["logGaEvent"],
    created(){
    },
    computed: {
      __swiper__() {
        if(this.questionList.length>0)
        return this.$refs.honorSwiper.swiper
      }
    },
    methods: {
      init:function(){
        var that = this;
        this.api.getSkillQuestionList({
        }, function(data) {
            for(var i=0;i<data.result.length;i++){
              data.result[i].value=3;
              data.result[i].image = [
                require("@/images/assessment/skills"+ data.result[i].design +"-1.png"),
                require("@/images/assessment/skills"+ data.result[i].design +"-2.png"),
                require("@/images/assessment/skills"+ data.result[i].design +"-3.png"),
                require("@/images/assessment/skills"+ data.result[i].design +"-4.png"),
                require("@/images/assessment/skills"+ data.result[i].design +"-5.png"),
              ];
            }
            that.totalRows = data.totalRows;
            that.$set(that, "questionList", data.result);
            that.transitionStart()
        })
      },
      transitionEnd:function(){
        this.$set(this, "swiperIndex", this.__swiper__.activeIndex+1);
        if(this.__swiper__.activeIndex>this.answerIndex){
          this.answerIndex = this.__swiper__.activeIndex;
        }
        var scoreData = []
        if(this.swiperIndex>6){
          for(var i=0;i<this.swiperIndex-1;i++){
            scoreData.push({
              "code":this.questionList[i].code,
              "score":this.questionList[i].value,
            })
          }
          this.getSkillOccupationList(scoreData)
        }else{
          this.occupationsList = [];
        }
          this.logGaEvent('userClick','selfSkillTopic-transitionEnd',this.swiperIndex)
      },
      handleChange:function(val){
      },
      transitionStart:function(){
        if(this.$store.state.innerWidth>840){
          var w = 840 - 70;
        }else{
          var w = this.$store.state.innerWidth - 70;
        }
        
        var left = w/this.totalRows*(this.__swiper__.activeIndex+1) -5;
        this.$refs.assessmentImg.style.transform = "translate3d("+ left +"px, 0px, 0px) "
        
        this.$set(this, "swiperIndex", this.__swiper__.activeIndex+1);
        if(this.__swiper__.activeIndex>this.answerIndex){
          this.answerIndex = this.__swiper__.activeIndex;
        }
      },
      getSkillOccupationList:function(scoreData){
        let Base64 = require('js-base64').Base64;
        var that = this;
        this.api.getSkillOccupationList({
          "scoreData":Base64.encode(JSON.stringify(scoreData))
        }, function(data) {
            // that.totalRows = data.totalRows;
            that.$set(that, "occupationsList", data.result);
        })
      },
      gotoMatches:function(){

        var scoreData = []
        if(this.swiperIndex>=6){
          for(var i=0;i<this.swiperIndex;i++){
            scoreData.push({
              "code":this.questionList[i].code,
              "score":this.questionList[i].value,
            })
          }
          this.$store.state.formData.scoreData = scoreData;
          this.$store.state.formData.scoreType = 1;
          this.logGaEvent('userClick','selfSkillTopic-gotoMatches',this.swiperIndex);
          this.$router.push({ path: '/careerMatches/', query:{lang:this.$store.state.language} });
           window.scrollTo(0, 0);
        }
      },
      goOccupationDetail:function(item){
        this.logGaEvent('userClick','selfSkillTopic-goOccupationDetail',item.id);
        // this.$router.push({path:'/occupationDetails/' + item.id, query:{lang:this.$store.state.language}})
        // window.scrollTo(0, 0);

        let routeData = this.$router.resolve({path:'/occupationDetails/' + item.id, query:{lang:this.$store.state.language}});
        window.open(routeData.href, '_blank');
      }
    },
    mounted() {
      this.$store.state.selectMenu =5;
      this.$store.state.formData.scoreData = [];
      this.$store.state.formData.scoreType = 0;
        this.$store.state.mate.title = this.$i18n.t("message.Self-Assessment")+" - talent.gov.hk"
      this.init()
    },
    watch:{
      questionList: {
        handler: function(val, oldVal) {
          for(var i=0;i<this.questionList.length;i++){
            // this.questionList[i].image = require("@/images/assessment/skills"+this.questionList[i].design+"-"+this.questionList[i].value+".png");
          }
        },
        deep: true
      }
    }
}
</script>